import { Injectable } from '@angular/core';
import { Firestore, query, where } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.abstract.service';
import { Portfolio } from '@models/portfolio';

@Injectable({
  providedIn: 'root'
})
/**
 * Service for managing team members in the Firebase Realtime Database.
 * Extends the FirebaseRTDBService to provide CRUD operations for TeamMember entities.
 */
export class PortfolioService extends FirestoreService<Portfolio> {

  /**
   * The base path for the team member collection in the database.
   */
  protected basePath = 'portfolio';

  /**
   * Creates an instance of TeamMemberService.
   * @param firestore - The Firestore instance to be used for database operations.
   */
  constructor(firestore: Firestore) {
    super(firestore);
  }

  /**
   * Creates a new team member.
   * @param project - The team member data to be created.
   * @returns A promise that resolves with the created team member or an error.
   */
  createProject(project: Portfolio): Promise<Portfolio | any | Error> {
    return this.create(project);
  }

  /**
   * Retrieves all team members.
   * @returns A promise that resolves with an array of team members.
   */
  getAllProject(): Promise<Portfolio[]> {
    return this.getCollection$();
  }

  /**
   * Retrieves a team member by their ID.
   * @param id - The ID of the team member to retrieve.
   * @returns A promise that resolves with the team member or false if not found.
   */
  getProjectById(id: string): Promise<Portfolio | any | false> {
    return this.getDocument(id);
  }

  /**
   * Retrieves all published team members.
   * @returns A promise that resolves with an array of published team members.
   */
  getAllPublishedProject(): Promise<Portfolio[]> {
    return this.getCollection$((collectionRef) => query(collectionRef, where('status', '==', 'publish')));
  }

  /**
   * Updates an existing team member.
   * @param teamMember - The team member data to be updated.
   * @returns A promise that resolves with the updated team member or an error.
   */
  updateProject(project: Portfolio): Promise<Portfolio | any | Error> {
    return this.update(project, project.uid);
  }

  DeleteProject(uid: string): Promise<Portfolio | any | Error> {
    return this.delete(uid);
  }

}
